import { FILTER_PS_DATA } from "./types";

export const filterPeakShavingData = filter => {
  return {
    type: FILTER_PS_DATA,
    payload: filter
  };
};



// WEBPACK FOOTER //
// ./src/actions/filterPeakShavingData.js